import React from 'react';
import { Helmet } from 'react-helmet-async';

const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://quantumframestudio.com/#website",
        "url": "https://quantumframestudio.com",
        "name": "QuantumFrame Studio",
        "description": "Professional Web Development & Digital Marketing Agency in Bhopal - Expert Website Design, SEO Services, and Digital Solutions",
        "publisher": {
          "@id": "https://quantumframestudio.com/#organization"
        },
        "potentialAction": [{
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://quantumframestudio.com/search?q={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }],
        "inLanguage": "en-IN"
      },
      {
        "@type": "Organization",
        "@id": "https://quantumframestudio.com/#organization",
        "name": "QuantumFrame Studio",
        "url": "https://quantumframestudio.com",
        "logo": {
          "@type": "ImageObject",
          "inLanguage": "en-IN",
          "@id": "https://quantumframestudio.com/#/schema/logo/image/",
          "url": "https://quantumframestudio.com/assets/images/quantumframe-logo.svg",
          "contentUrl": "https://quantumframestudio.com/assets/images/quantumframe-logo.svg",
          "width": 512,
          "height": 512,
          "caption": "QuantumFrame Studio"
        },
        "image": {
          "@id": "https://quantumframestudio.com/#/schema/logo/image/"
        },
        "description": "Leading web development and digital marketing agency in Bhopal, specializing in custom website design, SEO optimization, and comprehensive digital solutions for businesses.",
        "foundingDate": "2020",
        "founder": {
          "@type": "Person",
          "name": "QuantumFrame Studio Founder"
        },
        "slogan": "Transforming Digital Presence with Quantum Innovation",
        "knowsAbout": [
          "Web Development",
          "Digital Marketing",
          "SEO Services",
          "Website Design",
          "E-commerce Development",
          "Social Media Marketing",
          "Content Marketing",
          "UI/UX Design",
          "Mobile App Development",
          "Brand Development"
        ],
        "areaServed": [
          {
            "@type": "City",
            "name": "Bhopal",
            "sameAs": "https://en.wikipedia.org/wiki/Bhopal"
          },
          {
            "@type": "State",
            "name": "Madhya Pradesh",
            "sameAs": "https://en.wikipedia.org/wiki/Madhya_Pradesh"
          },
          {
            "@type": "Country",
            "name": "India",
            "sameAs": "https://en.wikipedia.org/wiki/India"
          }
        ]
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://quantumframestudio.com/#localbusiness",
        "name": "QuantumFrame Studio",
        "image": [
          "https://quantumframestudio.com/assets/images/quantumframe-logo.svg",
          "https://quantumframestudio.com/assets/images/quantumframe-office.jpg",
          "https://quantumframestudio.com/assets/images/team-photo.jpg"
        ],
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "123 IT Park, Zone-II",
          "addressLocality": "Bhopal",
          "addressRegion": "Madhya Pradesh",
          "postalCode": "462022",
          "addressCountry": "IN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 23.2599,
          "longitude": 77.4126
        },
        "hasMap": "https://www.google.com/maps/place/Bhopal,+Madhya+Pradesh/@23.2599,77.4126",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday", 
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "opens": "09:00",
            "closes": "18:00"
          }
        ],
        "telephone": "+91-9243015433",
        "email": "info@quantumframestudio.com",
        "url": "https://quantumframestudio.com",
        "sameAs": [
          "https://www.facebook.com/quantumframestudio",
          "https://www.instagram.com/quantumframestudio",
          "https://www.linkedin.com/company/quantumframestudio",
          "https://twitter.com/quantumframest"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "47",
          "bestRating": "5",
          "worstRating": "1"
        }
      },
      {
        "@type": "ProfessionalService",
        "@id": "https://quantumframestudio.com/#professionalservice",
        "name": "QuantumFrame Studio - Web Development & Digital Marketing Services",
        "alternateName": "QuantumFrame Studio Bhopal",
        "url": "https://quantumframestudio.com",
        "logo": "https://quantumframestudio.com/assets/images/quantumframe-logo.svg",
        "image": "https://quantumframestudio.com/assets/images/services-hero.jpg",
        "description": "Comprehensive web development and digital marketing services including custom website design, e-commerce development, SEO optimization, social media marketing, and brand development in Bhopal.",
        "priceRange": "₹₹",
        "serviceType": "Web Development and Digital Marketing",
        "provider": {
          "@id": "https://quantumframestudio.com/#organization"
        },
        "areaServed": {
          "@type": "GeoCircle",
          "geoMidpoint": {
            "@type": "GeoCoordinates",
            "latitude": 23.2599,
            "longitude": 77.4126
          },
          "geoRadius": "50000"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Web Development & Digital Marketing Services",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Custom Website Development",
                "description": "Professional responsive website development using modern technologies"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service", 
                "name": "SEO Services",
                "description": "Comprehensive search engine optimization to improve online visibility"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Digital Marketing",
                "description": "Strategic digital marketing campaigns across multiple channels"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "E-commerce Development",
                "description": "Full-featured online store development and optimization"
              }
            }
          ]
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://quantumframestudio.com/#homepage",
        "url": "https://quantumframestudio.com",
        "name": "QuantumFrame Studio - Web Development & Digital Marketing Agency Bhopal",
        "isPartOf": {
          "@id": "https://quantumframestudio.com/#website"
        },
        "about": {
          "@id": "https://quantumframestudio.com/#organization"
        },
        "description": "Leading web development and digital marketing agency in Bhopal offering professional website design, SEO services, and digital solutions for business growth.",
        "inLanguage": "en-IN",
        "mainEntity": {
          "@id": "https://quantumframestudio.com/#organization"
        }
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://quantumframestudio.com/#breadcrumb",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://quantumframestudio.com/"
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
      
      {/* Additional meta tags for enhanced SEO */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href="https://quantumframestudio.com/" />
      
      {/* Preload critical resources */}
      <link rel="preload" href="/assets/fonts/Poppins-Regular.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      <link rel="preload" href="/assets/fonts/Montserrat-SemiBold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      
      {/* DNS prefetch for external resources */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      
      {/* Preconnect to critical third-party origins */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default SchemaMarkup;